import { IntegrationStatus } from "../redux/types";

export const getHasArrayErrorStatus = (snippetStatusArray: (IntegrationStatus | undefined)[]): boolean => {
  if (!snippetStatusArray.length) {
    return false;
  }
  return snippetStatusArray.some((statusItem) => statusItem === IntegrationStatus.error);
};
